import React from 'react';
import LoadingSpinner from '../ui/LoadingSpinner';

interface LoadingOverlayProps {
  show: boolean;
  message?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ show, message = 'Loading...' }) => {
  if (!show) return null;

  return (
    <div className="absolute inset-0 bg-white/80 flex items-center justify-center z-50 animate-fadeIn">
      <div className="text-center">
        <LoadingSpinner size="lg" />
        <p className="mt-2 text-sm text-gray-600">{message}</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;